/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Homepage below-fold sections.
 * Streamlined to 5 sections: Trust Bar, Integrations, Product Showcase, Positioning, CTA.
 *
 * All components are SSR-safe — browser APIs (setInterval, scrollY) are
 * only used inside useEffect/event handlers, never during render.
 */

"use client";

import { TrustBarSection } from "@/components/landing/trust-bar-section";
import { IntegrationsStrip } from "@/components/landing/integrations-strip";
import { SocialProofSection } from "@/components/landing/social-proof-section";
import { ProductShowcaseSection } from "@/components/landing/product-showcase-section";
import { FinalCTASection } from "@/components/landing/final-cta-section";
import { StickyMobileCTA } from "@/components/landing/sticky-mobile-cta";
import { Footer } from "@/components/landing/footer";

export function HomeBelowFold() {
  return (
    <>
      <TrustBarSection />
      <IntegrationsStrip />
      <ProductShowcaseSection />
      <SocialProofSection />
      <FinalCTASection />
      <Footer />
      <StickyMobileCTA />
    </>
  );
}
